import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "uefa-content-list__card" }
const _hoisted_2 = { class: "uefa-content-list__card-date" }
const _hoisted_3 = { class: "uefa-content-list__card-content" }
const _hoisted_4 = { class: "uefa-content-list__card-item" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "uefa-content-list__card-result" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_card = _resolveComponent("content-card")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["uefa-content-list", { 'uefa-content-list--slider': _ctx.showSlider }]),
    "data-slider-pane": ""
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_content_card, {
          content: content.content,
          showTag: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(content.series), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$d(content.date, 'short')), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.items, (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: item.logo,
                    width: "40",
                    height: "40",
                    loading: "lazy"
                  }, null, 8, _hoisted_5),
                  _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(item.result), 1)
                ]))
              }), 256))
            ])
          ]),
          _: 2
        }, 1032, ["content"])
      ]))
    }), 256))
  ], 2))
}